import React from 'react';
import { useNavigate } from 'react-router-dom';
import SubPage from '../components/site/SubPage';
import { PageSection } from '../components/site/SubPageParts';
import { LEGAL_DOCUMENTS } from '../components/site/legalDocuments';

/**
 * One page for all the legal documents. The tabs swap the body in place; each
 * also owns a URL (/terms, /trademark, /cookies) so a link to a specific
 * policy stays stable and shareable.
 */
const LegalHub = ({ docId = 'terms' }) => {
  const navigate = useNavigate();
  const active = LEGAL_DOCUMENTS.find((doc) => doc.id === docId) || LEGAL_DOCUMENTS[0];

  return (
    <SubPage title="Legal">
      <PageSection className="pt-6">
        <div className="flex items-center justify-center border border-black/30 px-6 py-12 md:py-16">
          <h1 className="text-[46px] font-bold leading-none text-black md:text-[72px]">Legal</h1>
        </div>
      </PageSection>

      <PageSection className="pt-8">
        {/* Tabs */}
        <div role="tablist" aria-label="Legal documents" className="grid grid-cols-1 sm:grid-cols-3">
          {LEGAL_DOCUMENTS.map((doc) => {
            const isActive = doc.id === active.id;
            return (
              <button
                key={doc.id}
                type="button"
                role="tab"
                aria-selected={isActive}
                aria-controls="legal-panel"
                onClick={() => navigate(doc.path)}
                className={`px-4 pb-3 text-center text-[17px] transition-colors md:text-[20px] ${
                  isActive ? 'font-bold text-black' : 'text-black/70 hover:text-black'
                }`}
              >
                {doc.label}
              </button>
            );
          })}
        </div>
        <div className="h-px w-full bg-black/70" />

        {/* Active document */}
        <div id="legal-panel" role="tabpanel" className="pb-6 pt-8">
          <h2 className="text-[24px] font-bold text-black md:text-[32px]">{active.title}</h2>
          <div className="mt-6 max-w-[900px] space-y-10">{active.body}</div>
        </div>
      </PageSection>
    </SubPage>
  );
};

export default LegalHub;
